import * as React from 'react';

import { Box, StyleSheet } from '@coursera/coursera-ui';

import DefaultHeader from 'bundles/composable-page-header-consumer/header-renderers/DefaultHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';

// TODO: This is required for the ErrorPage component to retain its old look
import 'css!bundles/coursera-ui/styles/css/utilities';

const styles = StyleSheet.create({
  errorPageContent: {
    height: '100vh',
  },
});

export type Props = {
  title?: string;
  errorPageMsg?: string;
  errorPageIgnoreChildren?: boolean | React.ReactNode;
  disableHeader?: boolean;
  disableFooter?: boolean;
  children?: React.ReactNode;
};

export default function ErrorPage({
  title = 'ErrorPage',
  errorPageMsg,
  errorPageIgnoreChildren,
  disableHeader,
  disableFooter,
  children,
}: Props) {
  return (
    <div className="ErrorPage">
      <UniversalPageFeatures />
      {disableHeader ? null : <DefaultHeader showMetaNav />}
      <Box rootClassName={styles.errorPageContent} flexDirection="column" alignItems="center" justifyContent="center">
        <div className="max-text-width">
          <h2>{errorPageMsg}</h2>
          {errorPageIgnoreChildren ? null : children}
        </div>
      </Box>
      {disableFooter ? null : <PageFooter />}
      {/* For robots */}
      <CourseraMetatags
        metaNameAndProperties={{
          title,
          disableCourseraSuffix: true,
          disableCrawlerIndexing: true,
        }}
      />
    </div>
  );
}
